import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import type { ReactNode } from 'react';

interface InfoTooltipProps {
  children: ReactNode;
}

const InfoTooltip = ({ children }: InfoTooltipProps) => {
  return (
    <Tooltip 
      title={<>{children}</>}
      arrow
      placement="top"
    >
      <IconButton size="small" sx={{ p: 0.5 }}>
        <InfoIcon fontSize="small" color="primary" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
